import { useQuery } from "@tanstack/react-query";
import { useInstitutionStore } from "@/modules/auth/presentation/store/institution.store";
import { authContainer } from "@/modules/auth/di/container";
import { sinaremReportsContainer } from "../../di/container";

export function useStudentDetail(editionId: string, email: string) {
  const { institutionName } = useInstitutionStore();
  const isAuthenticated = institutionName
    ? authContainer.repository.isAuthenticated(institutionName)
    : false;

  return useQuery({
    queryKey: [
      "sinarem-reports",
      "student-detail",
      institutionName,
      editionId,
      email,
    ],
    queryFn: () =>
      sinaremReportsContainer.repository.getStudentDetail(editionId, email),
    enabled: isAuthenticated && !!editionId && !!email,
    retry: false,
  });
}
